import { appVersion } from '@shared/helper/configs';

export const environment = {
  version: appVersion,
  gtmId: import.meta.env.APP_ENV_GTM_ID,
  siteUrl: import.meta.env.APP_ENV_SITE_URL,
  authUrl: import.meta.env.APP_ENV_AUTH_URL,
  supportUrl: import.meta.env.APP_ENV_SUPPORT_URL,
  approveTvUrl: import.meta.env.APP_ENV_APPROVE_TV_URL,
  accountUrl: import.meta.env.APP_ENV_ACCOUNT_URL,
  apiUrl: import.meta.env.APP_ENV_API_URL,
  playPalUrl: import.meta.env.APP_ENV_PLAYPAL_URL,
  analyticsUrl: import.meta.env.APP_ENV_ANALYTICS_URL,
  ssrApiUrl: import.meta.env.APP_ENV_SSR_API_URL,
  viewCountUrl: import.meta.env.APP_ENV_VIEW_COUNT_URL,
  xSourceP: import.meta.env.APP_ENV_X_SOURCE_P,
  sentryDsn: import.meta.env.APP_ENV_SENTRY_DSN,
  recaptchaKey: import.meta.env.APP_ENV_RECAPTCHA_KEY,
};
